import { useState, useEffect } from 'react';
import { authService } from '../services/auth.service';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const unsubscribe = authService.onAuthChange(async (authUser) => {
      if (authUser) {
        const adminStatus = await authService.isAdmin(authUser.uid);
        setUser(authUser);
        setIsAdmin(adminStatus);
      } else {
        setUser(null);
        setIsAdmin(false);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const login = async (email, password) => {
    return await authService.login(email, password);
  };

  const logout = async () => {
    return await authService.logout();
  };

  const resetPassword = async (email) => {
    return await authService.resetPassword(email);
  };

  return {
    user,
    loading,
    isAdmin,
    login,
    logout,
    resetPassword
  };
};
